var path = require('../internals/path');

var has = require('../internals/has');

var wrappedWellKnownSymbolModule = require('../internals/wrapped-well-known-symbol');

var defineProperty = require('../internals/object-define-property').f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};